let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("g4FYy"), load("6wr18"), load("37ldp"), load("ffEVr"), load("9vWDd")]).then(() => parcelRequire('sc949'));